import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { z } from 'zod';
import { type VerifyPasswordRecoveryCodeRequestDto } from '@/features/auth-login';

interface UsePasswordRecoveryConfirmFormOptions {
  email: string;
}

const usePasswordRecoveryConfirmForm = ({
  email,
}: UsePasswordRecoveryConfirmFormOptions) => {
  const { t } = useTranslation();

  const required = t('authPages.validation.requiredField');
  const otpIncorrect = t('authPages.validation.otpIncorrect');

  const otpCodeSchema = z
    .string()
    .regex(/^\d+$/, { message: otpIncorrect })
    .nonempty({ message: required });

  const schema = z.object({
    code: otpCodeSchema,
    email: z.string().email({ message: required }),
  });

  const form = useForm<VerifyPasswordRecoveryCodeRequestDto>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues: {
      code: '',
      email,
    },
  });

  useEffect(() => {
    if (form.formState.isSubmitted) {
      form.trigger();
    }
  }, [t]);

  const setServerError = (errorMessage: string) => {
    form.setError('code', {
      type: 'server',
      message: errorMessage,
    });
  };

  const clearServerError = () => {
    form.clearErrors('code');
  };

  return { form, setServerError, clearServerError };
};

export { usePasswordRecoveryConfirmForm };
